import React from 'react';
import imgLogo from '../base/images/favi/ICO_180.png';
import imgLogoBallsGradient from '../base/images/LogoBallsGradient.svg';
import imgLogoBallsLight from '../base/images/LogoBallsLight.svg';


function ImgLogo({ ...props }) {
    return (
        <div className="noselect">
            <img src={imgLogo} className='img-logo' alt="Info" {...props} />
        </div>
    );
}

function ImgLogoBallsGradient({ ...props }) {
    return (
        <div className="noselect">
            <img src={imgLogoBallsGradient} className='img-logo' alt="Info" {...props} />
        </div>
    );
}

function ImgLogoBallsLight({ ...props }) {
    return (
        <div className="noselect">
            <img src={imgLogoBallsLight} className='img-logo' alt="Info" {...props} />
        </div>
    );
}

export {
    ImgLogo,
    ImgLogoBallsGradient,
    ImgLogoBallsLight
}; 